import colors from "./colors";

const legacyColors = {
  paletteAvatarLight: "#B47DF4", // purple
  paletteAvatarDark: "#B47DF4",

  // Navbar needs custom light/dark match
  paletteNavbarBackgroundLight: colors.paletteBlue1Light,
  paletteNavbarBackgroundDark: colors.paletteBlue2Dark,

  // Workflow custom colors

  paletteWorkflowStateBookedLight: "#1F78B4",
  paletteWorkflowStateBookedDark: "#1F78B4",

  paletteWorkflowStateAutoShortlistingLight: "#6ef29c4d",
  paletteWorkflowStateAutoShortlistingDark: "#6ef29c4d",

  paletteWorkflowStateManualShortlistingLight: "#6ef29c80",
  paletteWorkflowStateManualShortlistingDark: "#6ef29c80",

  paletteWorkflowStateAutoFillingLight: "#0043b84d",
  paletteWorkflowStateAutoFillingDark: "#0043b84d"
};

export default legacyColors;
